import { $t } from "../../../utils/intl";
import { handleNumberField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextFieldValue } from "../text/text.config";
import { CurrencyFieldControl } from "./CurrencyFieldControl/CurrencyFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

export const currencyFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "currency",
  control: (props) => (
    <CurrencyFieldControl
      placeholder={$t(fieldsText.currencyPlaceholder)}
      type="number"
      {...props}
    />
  ),
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
